import { render, staticRenderFns } from "./SettingsMrDocumentTemplateFields.vue?vue&type=template&id=b6cba1e4"
import script from "./SettingsMrDocumentTemplateFields.vue?vue&type=script&lang=js"
export * from "./SettingsMrDocumentTemplateFields.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports